import 'babel-polyfill';
import './_polyfill';
import './components/_slider';

import { ready } from 'dauphine-js';


import Accordion from './components/_accordion';

import './components/_modal';

import './components/_search';
import './components/_tabs';
import './components/_showMore';
import './components/_photoswipe';
import './components/_galleryShowMore';
import './components/_form';

import Menu from './components/_menu';

import ScrollTo from './components/_scrollTo';

import Roll from './components/_scrollStatus';

import './animations/_loader';

Lazyload.init();

Accordion.init();

Menu.init();

ScrollTo.init();

Roll.init();

ready(() => {
    require('./components/_banner');
});